import React from 'react';
import { Card, Row, Col } from 'antd';
import { BarChartOutlined, PieChartOutlined } from '@ant-design/icons';
import ChartContainer from '../../components/shared/ChartContainer';
import { mockRevenueData, mockRevenueGrowthTrend } from '../data/mockData';

const RevenueCharts: React.FC = () => {
  const { breakdown } = mockRevenueData;

  // Revenue trend chart
  const revenueTrendData = {
    labels: mockRevenueGrowthTrend.map(item => item.month),
    datasets: [
      {
        label: 'Monthly Revenue ($)',
        data: mockRevenueGrowthTrend.map(item => item.revenue),
        borderColor: '#1890ff',
        backgroundColor: 'rgba(24, 144, 255, 0.1)',
        fill: true,
      },
      {
        label: 'Growth Rate (%)',
        data: mockRevenueGrowthTrend.map(item => item.growth),
        borderColor: '#52c41a',
        backgroundColor: 'rgba(82, 196, 26, 0.1)',
        yAxisID: 'y1',
        fill: false,
      },
    ],
  };

  // Service type breakdown
  const serviceTypeData = {
    labels: breakdown.byServiceType.map(item => item.service),
    datasets: [
      {
        label: 'Revenue ($)',
        data: breakdown.byServiceType.map(item => item.revenue),
        backgroundColor: ['#1890ff', '#52c41a', '#faad14', '#722ed1'],
      },
    ],
  };

  // Client tier breakdown
  const clientTierData = {
    labels: breakdown.byClientTier.map(item => item.tier),
    datasets: [
      {
        label: 'Revenue ($)',
        data: breakdown.byClientTier.map(item => item.revenue),
        backgroundColor: ['#faad14', '#52c41a', '#1890ff'],
      },
    ],
  };

  // Coach performance
  const coachPerformanceData = {
    labels: breakdown.byCoach.map(item => item.coachName),
    datasets: [
      {
        label: 'Revenue Generated ($)',
        data: breakdown.byCoach.map(item => item.revenue),
        backgroundColor: 'rgba(24, 144, 255, 0.6)',
        borderColor: '#1890ff',
        borderWidth: 1,
      },
    ],
  };

  return (
    <div>
      <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
        <Col span={24}>
          <ChartContainer
            title={
              <span>
                <BarChartOutlined /> Revenue Trend & Growth Rate
              </span>
            }
            type="line"
            data={revenueTrendData}
            height={400}
          />
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
        <Col span={12}>
          <ChartContainer
            title={
              <span>
                <PieChartOutlined /> Revenue by Service Type
              </span>
            }
            type="pie"
            data={serviceTypeData}
            height={300}
          />
        </Col>
        <Col span={12}>
          <ChartContainer
            title="Revenue by Client Tier"
            type="pie"
            data={clientTierData}
            height={300}
          />
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col span={24}>
          <ChartContainer
            title="Coach Performance - Revenue Generated"
            type="bar"
            data={coachPerformanceData}
            height={300}
          />
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        <Col span={8}>
          <Card title="Service Performance">
            {breakdown.byServiceType.map((service, index) => (
              <div key={index} style={{ marginBottom: 12 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>{service.service}</span>
                  <span style={{ fontWeight: 'bold' }}>${service.revenue.toLocaleString()}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', color: '#666' }}>
                  <span>{service.clientCount} clients</span>
                  <span>{service.percentage.toFixed(1)}%</span>
                </div>
              </div>
            ))}
          </Card>
        </Col>
        <Col span={8}>
          <Card title="Tier Performance">
            {breakdown.byClientTier.map((tier, index) => (
              <div key={index} style={{ marginBottom: 12 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>{tier.tier}</span>
                  <span style={{ fontWeight: 'bold' }}>${tier.revenue.toLocaleString()}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', color: '#666' }}>
                  <span>Avg: ${tier.avgPrice.toLocaleString()}</span>
                  <span>{tier.percentage.toFixed(1)}%</span>
                </div>
              </div>
            ))}
          </Card>
        </Col>
        <Col span={8}>
          <Card title="Top Performing Coaches">
            {breakdown.byCoach.slice(0, 4).map((coach, index) => (
              <div key={index} style={{ marginBottom: 12 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <span>{coach.coachName}</span>
                  <span style={{ fontWeight: 'bold' }}>${coach.revenue.toLocaleString()}</span>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '12px', color: '#666' }}>
                  <span>{coach.clientCount} clients</span>
                  <span>Avg: ${coach.avgRevenue.toLocaleString()}</span>
                </div>
              </div>
            ))}
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default RevenueCharts; 